/**
 * BAZADA saqlanadigan tillar — `TranslatableString` ning kalitlari.
 *
 * O'zbek KIRILLCHASI bu ro'yxatda ATAYLAB yo'q: u lotinchadan
 * avtomatik o'giriladi (`utils/cyrillic.ts`). Alohida maydon bo'lganda
 * mijoz butun saytni ikki marta kiritishi kerak bo'lardi, ikki nusxa
 * esa vaqt o'tib bir-biridan uzoqlashardi.
 */
export const CONTENT_LOCALES = ['uz', 'ru', 'en'];
/**
 * SAYTDA ochiladigan tillar — manzil prefikslari (`/uz`, `/oz`, ...).
 * Tartib muhim: switcher va `sitemap.xml` shu tartibda chiqadi.
 *
 * `oz` — o'zbek kirillchasi. Uning kontenti `uz` dan olinadi va
 * ko'rsatishdan oldin kirillga o'giriladi.
 */
export const LOCALES = ['uz', 'oz', 'ru', 'en'];
/** Sayt tili qaysi kontent tilidan oziqlanadi. */
export const LOCALE_CONTENT_SOURCE = {
    uz: 'uz',
    oz: 'uz',
    ru: 'ru',
    en: 'en',
};
/**
 * Sayt tilining bazadagi manbasi.
 *
 * Bazadagi maydonga (`searchText.uz`, `title.ru`) murojaat qilishdan
 * OLDIN shu funksiya chaqiriladi: `oz` degan maydon bazada yo'q va
 * to'g'ridan-to'g'ri ishlatilsa so'rov hech narsa topmasdi.
 */
export function contentLocaleOf(locale) {
    return (locale && LOCALE_CONTENT_SOURCE[locale]) || FALLBACK_LOCALE;
}
/** Matni kirillga o'giriladigan tillar. */
export const TRANSLITERATED_LOCALES = ['oz'];
export function isTransliteratedLocale(locale) {
    return TRANSLITERATED_LOCALES.includes(locale);
}
/**
 * `<html lang>` va `hreflang` uchun BCP-47 kodlari.
 *
 * `oz` — bizning ichki qisqartmamiz, standart kod emas. Qidiruv
 * tizimlariga va ekranni o'quvchi dasturlarga `uz-Cyrl` berilishi
 * shart: aks holda ular sahifani noma'lum tilda deb qabul qiladi.
 */
export const LOCALE_BCP47 = {
    uz: 'uz-Latn',
    oz: 'uz-Cyrl',
    ru: 'ru',
    en: 'en',
};
/**
 * `og:locale` — ijtimoiy tarmoqlar uchun `til_HUDUD`.
 *
 * Bu yerda yozuv turi KO'RSATILMAYDI: Facebook va Telegram
 * `uz_Cyrl` ni tanimaydi va butun teg e'tiborsiz qolardi. Ular uchun
 * ikkala o'zbek yozuvi ham `uz_UZ`.
 */
export const LOCALE_OG = {
    uz: 'uz_UZ',
    oz: 'uz_UZ',
    ru: 'ru_RU',
    en: 'en_US',
};
/** Til to'ldirilmagan bo'lsa shu tildagi matn ko'rsatiladi (CLAUDE.md §4). */
export const FALLBACK_LOCALE = 'uz';
export const DEFAULT_LOCALE = 'uz';
/**
 * Rollar. Yuqoridan pastga — huquqlar kamayadi.
 * `sales` alohida turadi: u faqat arizalar bilan ishlaydi, kontentga tegmaydi.
 */
export const ROLES = ['superadmin', 'admin', 'editor', 'sales'];
/** Kontent tahrirlay oladigan rollar. */
export const CONTENT_ROLES = ['superadmin', 'admin', 'editor'];
/** Nashr qila oladigan rollar (`editor` qila olmaydi — TZ 3.2). */
export const PUBLISH_ROLES = ['superadmin', 'admin'];
/** O'chira oladigan rollar. */
export const DELETE_ROLES = ['superadmin', 'admin'];
/** Arizalarni ko'ra oladigan rollar. */
export const REQUEST_ROLES = ['superadmin', 'admin', 'sales'];
export const CURRENCY = 'UZS';
/** Sahifalash. `MAX_PAGE` — `skip()` ning sekinlashuvidan himoya (ISH-REJA §4.6). */
export const PAGINATION = {
    DEFAULT_PAGE: 1,
    DEFAULT_LIMIT: 20,
    MAX_LIMIT: 100,
    MAX_PAGE: 100,
};
/** Hujjat ichidagi massivlar uchun chegara (ISH-REJA §4.3). */
export const EMBEDDED_LIMITS = {
    PRODUCT_VARIANTS: 20,
    SPEC_GROUPS: 20,
    SPEC_ROWS_PER_GROUP: 40,
    PAGE_BLOCKS: 40,
    MENU_ITEMS: 40,
    MENU_DEPTH: 2,
    REQUEST_NOTES: 50,
    GALLERY_IMAGES: 40,
};
export const SLUG_PATTERN = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
/** O'zbekiston telefon raqami: +998 XX XXX XX XX */
export const PHONE_PATTERN = /^\+998\d{9}$/;
// ─── Do'kon ──────────────────────────────────────────────────────────────────
/** Komplektatsiya mavjudligi (TZ 3.9). Ombordagi dona soni yuritilmaydi. */
export const AVAILABILITY = ['in_stock', 'on_order', 'out_of_stock'];
// ─── Arizalar ────────────────────────────────────────────────────────────────
/** Ariza turlari (TZ 3.13). Barchasi bitta `requests` kolleksiyasida. */
export const REQUEST_TYPES = [
    'product',
    'cart',
    'drone_show',
    'repair',
    'course',
    'service',
    'general',
];
export const REQUEST_STATUSES = ['new', 'in_progress', 'quoted', 'won', 'lost', 'spam'];
/** Ariza raqami: GEO-2026-00042 */
export const REQUEST_NUMBER_PREFIX = 'GEO';
export const REQUEST_NUMBER_PATTERN = /^[A-Z]{2,6}-\d{4}-\d{5}$/;
// ─── Sertifikatlar ───────────────────────────────────────────────────────────
/**
 * Sertifikat holati (docs/12-SERTIFIKAT-REJA.md §1.1).
 *
 * «Muddati tugagan» holat YO'Q: u `expiresAt` dan hisoblanadi. Alohida
 * maydon bo'lsa, uni har kuni yangilab turadigan ish kerak bo'lardi va
 * yangilanmay qolgan yozuv saytda «haqiqiy» deb ko'rinardi.
 */
export const CERTIFICATE_STATUSES = ['active', 'revoked'];
/** Saytda ko'rsatiladigan holat — `status` va `expiresAt` dan hisoblanadi. */
export const CERTIFICATE_VERDICTS = ['valid', 'expired', 'revoked'];
/**
 * Sertifikat bilan ishlay oladigan rollar (mijoz talabi).
 * `editor` va `sales` KIRA OLMAYDI — rasmiy hujjat.
 */
export const CERTIFICATE_ROLES = ['superadmin', 'admin'];
/**
 * Seriya raqami — qog'ozdagi bosilgan raqam (`0000976`), qo'lda kiritiladi.
 * Tizim avtomatik davom ettirmaydi (mijoz qarori §3.2).
 */
export const CERTIFICATE_NUMBER_PATTERN = /^[0-9A-Za-z][0-9A-Za-z/-]{0,31}$/;
export const CERTIFICATE = {
    /**
     * Tekshirish kodi uzunligi baytda. 16 bayt → base64url da 22 belgi,
     * 2^128 variant: manzilni terib topib bo'lmaydi (reja §3, 6-qaror).
     */
    VERIFY_CODE_BYTES: 16,
    /** Shabloncha yozilgan amal qilish muddati. */
    VALIDITY_YEARS: 3,
    /** Uzaytirish ham shuncha muddatga. */
    EXTENSION_YEARS: 3,
    /** O'qish hajmi (soat) chegaralari. */
    MIN_HOURS: 1,
    MAX_HOURS: 10_000,
};
/** `verifyCode` — base64url alifbosi, aynan 22 belgi. */
export const CERTIFICATE_VERIFY_CODE_PATTERN = /^[A-Za-z0-9_-]{22}$/;
// ─── Xizmatlar ───────────────────────────────────────────────────────────────
/** `main` — aerofototasvir, 3D-model; `repair` — ta'mirlash va texnik xizmat. */
export const SERVICE_TYPES = ['main', 'repair'];
// ─── Media ───────────────────────────────────────────────────────────────────
/** Ruxsat etilgan MIME turlari. `.svg` va `.html` ATAYLAB yo'q (TZ 10.1). */
export const ALLOWED_IMAGE_MIME = ['image/jpeg', 'image/png', 'image/webp'];
export const ALLOWED_FILE_MIME = ['application/pdf'];
export const MEDIA_LIMITS = {
    IMAGE_MAX_BYTES: 10 * 1024 * 1024,
    FILE_MAX_BYTES: 25 * 1024 * 1024,
};
/** Rasm variantlari (TZ 10.1 + ISH-REJA: `square` katalog kartochkalari uchun). */
export const MEDIA_VARIANTS = {
    large: 1920,
    medium: 960,
    square: 800,
    thumb: 320,
};
// ─── Ko'rishlar hisoblagichi ────────────────────────────────────────────────
/** Hot-write asosiy hujjatdan ajratilgan (ISH-REJA §4.2). */
export const VIEW_COUNTER_ENTITIES = ['product', 'news'];
export const TTL_DAYS = {
    VIEW_COUNTERS: 400,
    AUDIT_LOGS: 365,
};
// ─── Tahrirlash: qoralama, qulf, ko'rish ────────────────────────────────────
/** Blok konstruktori talablari (TZ 7.2 §6–9). */
export const EDITING = {
    /** Avtosaqlash oralig'i — admin shu qadamda `PUT :id/draft` yuboradi. */
    AUTOSAVE_INTERVAL_MS: 30_000,
    /**
     * Qulf shuncha vaqtdan keyin o'z-o'zidan bo'shaydi.
     *
     * Brauzer yopilganda `DELETE :id/lock` yetib bormaydi — TTL bo'lmasa
     * sahifa abadiy band bo'lib qolardi.
     */
    LOCK_TTL_SECONDS: 120,
    /** Admin qulfni shu oraliqda yangilaydi — TTL ning yarmidan kam bo'lishi shart. */
    LOCK_HEARTBEAT_MS: 45_000,
    /** «Ko'rish» havolasi shuncha yashaydi. */
    PREVIEW_TOKEN_TTL_SECONDS: 900,
};
//# sourceMappingURL=index.js.map